import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { withStyles } from "@material-ui/core/styles";
import { Row, Col } from "react-flexbox-grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Link } from "react-router-dom";
import LoginButton from "../login/login-button";

const styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  logo: {
    maxWidth: 240
  },
  textMenu : {
    fontFamily : "'Poppins', sans-serif",
    fontSize : 15
  },
  text : {
    color : '#0D6939',
    fontFamily : "'Poppins', sans-serif"
  },
};

class MenuAppBar extends React.Component {
  state = {
    open: false
  };

  toggleDrawer = () =>
    this.setState(state => ({
      open: !state.open
    }));

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={this.toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              color="inherit"
              className={classes.grow}
            >
              Atlas de la salud de Colombia
            </Typography>
            <LoginButton />
          </Toolbar>
        </AppBar>
        <Drawer open={this.state.open} onClose={this.toggleDrawer}>
          <List>
            <ListItem>
              <Row center="xs" className={classes.logo}>
                <Col xs={12} className="flex justify-center">
                  <img 
                    src="https://vgde-files.s3.amazonaws.com/LogoFacultadNacionaldeSaludPublica.png"  
                    alt="logo" 
                    width="180" 
                    height="80" 
                  />
                </Col>
                <Col xs={12}>
                  <Typography className={classes.text} variant="caption">Grupo de Investigación de Epidemiología</Typography>
                </Col>
              </Row>
            </ListItem>
            <ListItem component={Link} to="/home" onClick={this.toggleDrawer}>
              <Typography className={classes.textMenu}>Home</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/project/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>El proyecto</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/credits/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Créditos</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/methodology/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Metodología</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/researchers/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Investigadores</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/publications/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Publicaciones</Typography>
            </ListItem>
            <ListItem 
              component={Link} 
              to="/faq/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Preguntas frecuentes</Typography>
            </ListItem>
            <ListItem
              component={Link}
              to="/references/"
              onClick={this.toggleDrawer}
            >
              <Typography className={classes.textMenu}>Citando</Typography>
            </ListItem>
          </List>
        </Drawer>
      </div>
    );
  }
}

MenuAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MenuAppBar);



// WEBPACK FOOTER //
// ./src/components/menuBar/index.js